module.exports = __webpack_public_path__ + "img/fis.7822e549.png";